const GridElementItemModel = {
  position: 1,
  title: { pl: '' },
  description: { pl: '' },
  file: {
    base64: '',
    fileName: '',
    delete: false,
  },
  iconUrl: '',
};

export default GridElementItemModel;
